<template>
  <PropertySection
    title="ぐるなび予約との連携"
    :button="gnaviSyncStatus ? 'ぐるなび予約連携方式の切替' : '認証キー登録'"
    small
    @click="onClick()"
  >
    <template #text>
      <div :class="['label', { synced: gnaviSyncStatus }]" :key="gnaviSyncStatus">
        {{ gnaviSyncStatus ? '連携中' : '未連携' }}
      </div>
    </template>
    <template #descSlot>
      <div class="desc">
        <template v-if="gnaviSyncStatus">
          連携停止を行うには
          <BrowserOpen url="https://manage.gnavi.co.jp/rsv/reservation-ledger">予約管理</BrowserOpen>
          にて停止の操作を行ってください。
        </template>
        <template v-else>
          ぐるなび予約と連携を行うには、
          <BrowserOpen url="https://manage.gnavi.co.jp/rsv/reservation-ledger">予約管理</BrowserOpen>
          にて認証キーを発行し、認証キーを入力してください。
        </template>
      </div>
    </template>
    <GnaviSyncSettingModal
      v-if="gnaviSyncSettingModal"
      :status="gnaviSyncStatus"
      :type="gnaviSyncType"
      @close="gnaviSyncSettingModal = false"
      @save="saveGnaviSyncSetting"
    />
  </PropertySection>
</template>

<script>
import BrowserOpen from '@/components/atoms/BrowserOpen'
import PropertySection from '@/components/molecules/PropertySection'
import Dialog from '@/components/molecules/ModalDialog'
import GnaviSyncSettingModal from '@/components/organisms/GnaviSyncSettingModal'

export default {
  name: 'GnaviSync',
  components: {
    BrowserOpen,
    PropertySection,
    GnaviSyncSettingModal,
  },
  props: {
    gnaviSyncType: { type: Number, required: true },
    gnaviSyncStatus: { type: Number, required: true },
    resrakuSyncStatus: { type: Number, required: true },
  },
  data() {
    return {
      gnaviSyncSettingModal: false,
    }
  },
  computed: {},
  methods: {
    onClick() {
      if (this.resrakuSyncStatus === 3) {
        Dialog.show({
          title: '認証キーの登録',
          message: 'レスラク連携中のためご利用いただけません',
          okText: '閉じる',
        })
        return
      }
      this.gnaviSyncSettingModal = true
    },
    async saveGnaviSyncSetting({ collaborationType, collaborationKey }) {
      this.gnaviSyncSettingModal = false
      if (
        await this.$store.dispatch('stores/gnaviStart/save', {
          collaborationType,
          collaborationKey,
        })
      ) {
        location.reload()
      }
    },
  },
}
</script>
